export enum PaymentLayout {
    Accordion = "accordion",
    Tabs = "tabs",
}